import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "menu-items" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "no-alcohol"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "add" }, "+", -1)
const _hoisted_5 = { class: "square-image" }
const _hoisted_6 = ["src"]

import store from '@/store'
import { Item } from '@/store/Order'


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItems',
  setup(__props) {

const addToCart = (item: Item) => {
  store.addToCart(item)
}
const items = store.get(state => state.items)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "menu-items__item",
        onClick: ($event: any) => (addToCart(item))
      }, [
        (!item.alcohol)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "ALKOHOLFREI"))
          : _createCommentVNode("", true),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: require(`@/assets/items/${item.id}.png`)
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("h3", null, _toDisplayString(item.name), 1),
        _createElementVNode("p", null, "AKA. " + _toDisplayString(item.alias), 1)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})